import React from 'react';
import { browserName } from 'react-device-detect';
import { Trans, useTranslation } from 'react-i18next';
import { Popover } from '@barges/react';
import classes from './classes.module.scss';
import { downloadAppLink } from '../../../../common/config/utils';
import Const from '../../../config/const';

const extractErrors = (error) => {
  if (error.errors) {
    return error.errors.map((e, i) => <div key={ i }>{e}</div>);
  }
  if (error.voipErrors) {
    return error.voipErrors.map((e, i) => <div key={ i }>{e}</div>);
  }
  return null;
};

const getLearnMoreLink = () => {
  switch (browserName) {
    case 'Chrome':
      return 'https://support.google.com/chrome/answer/2693767?co=GENIE.Platform%3DDesktop&hl=en';
    case 'Firefox':
      return 'https://support.mozilla.org/en-US/kb/how-manage-your-camera-and-microphone-permissions';
    case 'Safar':
      return 'https://support.apple.com/en-il/guide/safari/ibrwe2159f50/mac';
    case 'Opera':
      return 'https://help.opera.com/en/opera36/set-web-preferences/';
    default:
      return 'https://www.online-tech-tips.com/computer-tips/how-to-block-camera-and-mic-access-in-every-major-browser/';
  }
};

const renderTitle = (permissionDeniedError) => {
  if (permissionDeniedError) {
    return (
      <div className={ classes.dialogTitle }>
        Microphone and/or camera blocked
      </div>
    );
  }
  return null;
};

const renderText = (permissionDeniedError, error, onCancelClicked) => {
  if (permissionDeniedError) {
    return (
      <>
        To order a live voice/video call,
        you&apos;ll need to allow access to your microphone and/or camera.&nbsp;
        <a href={ getLearnMoreLink() } target="_blank" rel="noopener noreferrer" className={ classes.link } onClick={ onCancelClicked }>
          Learn more
        </a>
        .
      </>
    );
  }
  return (extractErrors(error));
};

const appLinkAFChanel = (chatType) => {
  switch (chatType) {
    case Const.chatType.video:
      return 'video_button';
    case Const.chatType.voice:
      return 'voice_button';
    case Const.chatType.text:
      return 'chat_button';
    default:
      return null;
  }
};

function Error({
  error,
  onCancelClicked,
  chatType,
  permissionDeniedError,
  url
}) {
  const { t } = useTranslation();
  return (
    <Popover isOpen centered className={ classes.errorPopover }>
      { renderTitle(permissionDeniedError) }
      <div className={ classes.dialogText }>
        {' '}
        { renderText(permissionDeniedError, error, onCancelClicked) }
        <a href={ downloadAppLink({ afChanel: appLinkAFChanel(chatType), url }) } target="_blank" rel="noopener noreferrer" className={ classes.link } onClick={ onCancelClicked }>
          <Trans
            i18nKey="app_general.download_link"
            components={ {
              downloadLink: <a href={ downloadAppLink({ afChanel: appLinkAFChanel(chatType), url }) } target="_blank" rel="noopener noreferrer" className={ classes.link } onClick={ onCancelClicked } />
            } }
          />
        </a>
      </div>
      <div
        className={ classes.cancelButton }
        onClick={ onCancelClicked }
        onKeyDown={ onCancelClicked }
      >
        <div className={ classes.okBtn }>{t('general.ok')}</div>
      </div>
    </Popover>
  );
}

export default Error;
